// @Vendors
import React, { Component } from 'react';

export default class Dashboard extends Component {
  render() {
    return (
      <div className='row'>
        <div id='top_body'>
          <h1 className='big'>Dashboard</h1>
        </div>
      </div>
    );
  }
}




// WEBPACK FOOTER //
// ./src/pages/Dashboard/index.js